import React from "react";
import LandingLayout from "../landing/LandingLayout";
import { HomePage } from "../landing/HomePage";

export default function Home() {
  return (
    <LandingLayout>
      <HomePage />
    </LandingLayout>
  );
}
